import {
  POST_SESSION_BEGIN, POST_SESSION_FAILURE, POST_SESSION_SUCCESS, DELETE_SESSION_BEGIN, DELETE_SESSION_SUCCESS,
  DELETE_SESSION_FAILURE,
  FETCH_SESSION_BEGIN,
  FETCH_SESSION_SUCCESS,
  FETCH_SESSION_FAILURE, UPDATE_LOGIN_MESSAGE, UPDATE_RECAPTCHA_ID, SET_TARGET_URL,
  SHOW_2FA_SETUP_DIALOG, DISMISS_2FA_SETUP_DIALOG,
  POST_OTP_BEGIN, POST_OTP_SUCCESS, POST_OTP_FAILURE,
  RESET_SUBMIT_STATE, SET_OTP_TOKEN
} from "../actions/login";
import {AnyAction} from "redux";
import {LoginState} from "./index";
import {updateObject} from "../utils/miscUtils";

const initialState = {
  showRecaptcha: false,
  failedAttempts: 0,
  email: "",
  firstName: "",
  lastName: "",
  id: -1,
  superAdmin: false,
  message: null,
  recaptcha: 0,
  isSubmitted: false,
  targetUrl: null,
  twoFaSetupUrl: null,
  otpToken: sessionStorage.getItem('otpToken') || null
};

const login = (state: LoginState = initialState, action: AnyAction) => {

  switch(action.type) {
    case UPDATE_RECAPTCHA_ID:
      return updateObject(state, {
        recaptcha: action.id
      })
    case UPDATE_LOGIN_MESSAGE:
      return updateObject(state, {
        message: action.message
      })
    case POST_SESSION_BEGIN:
      return updateObject(state, {
        message: null,
        isSubmitted: true,
        twoFaSetupUrl: null
      })
    case POST_SESSION_FAILURE:
    case FETCH_SESSION_FAILURE:
      return updateObject(state, {
        failedAttempts: action.failedAttempts,
        showRecaptcha: action.showRecaptcha,
        isSubmitted: false
      })
    case POST_SESSION_SUCCESS:
    case FETCH_SESSION_SUCCESS:
      const sessionData = action.payload.session;

      return updateObject(state, {
        failedAttempts: 0,
        showRecaptcha: false,
        email: sessionData.email,
        firstName: sessionData.firstName,
        lastName: sessionData.lastName,
        id: sessionData.id,
        superAdmin: sessionData.superAdmin,
        isSubmitted: false
      })
    case DELETE_SESSION_SUCCESS:
    case DELETE_SESSION_FAILURE:
      const clearedState = updateObject(initialState, {
        recaptcha: state.recaptcha
      })
      return updateObject(state, clearedState)
    case FETCH_SESSION_BEGIN:
    case DELETE_SESSION_BEGIN:
      return state
    case SET_OTP_TOKEN:
      return updateObject(state, {
        otpToken: action.otpToken
      })
    case SET_TARGET_URL:
      return updateObject(state, {
        targetUrl: action.payload.targetUrl
      })
    case SHOW_2FA_SETUP_DIALOG:
      return updateObject(state, {
        twoFaSetupUrl: action.setupUrl,
        isSubmitted: false
      })
    case DISMISS_2FA_SETUP_DIALOG:
      return updateObject(state, {
        twoFaSetupUrl: null
      })
    case POST_OTP_BEGIN:
      return updateObject(state, {
        message: null,
        isSubmitted: true
      })
    case POST_OTP_SUCCESS:
      return updateObject(state, {
        isSubmitted: false,
        otpToken: null
      })
    case POST_OTP_FAILURE:
      return updateObject(state, {
        isSubmitted: false
      })
    case RESET_SUBMIT_STATE:
      return updateObject(state, {
        isSubmitted: false
      })
    default:
      return state
  }
};

export default login;
